import Component, { mixins } from 'vue-class-component'

import WithRender from './LoginPage.html'

import { 
  MPanel
} from '@ulaval/modul-components'

import AuthenticationForm from '@/modules/authentication/form/AuthenticationForm'

import { STORE_GETTERS } from '@/store';

import IInscriptionLieuExamenInformations from '@/modules/inscription-lieu-examen/IInscriptionLieuExamenInformations.model';

@WithRender
@Component({
  components: {
    AuthenticationForm,
    MPanel
  }
})
export default class LoginPage extends mixins() {
  private get inscriptionLieuExamenInformations(): IInscriptionLieuExamenInformations | null {
    return this.$store.getters[STORE_GETTERS.INSCRIPTION_LIEU_EXAMEN_GET_INFORMATIONS]
  }
}
